import { Link } from "react-router-dom";
import { Menu } from "lucide-react";

import { Button } from "@/components/ui/button";
import logo from "@/assets/logo_small.png";

import { useHeaderUser } from "./header/use-header-user";
import { EnvironmentBar } from "./header/EnvironmentBar";
import { HeaderActions } from "./header/HeaderActions";
import { UserDropdown } from "./header/UserDropdown";
import { ComunicadosBoundary } from "@/components/comunicados/ComunicadosBoundary";
import { ComunicadoSistemaBar } from "@/components/comunicados/ComunicadoSistemaBar";

interface HeaderProps {
  isMobile: boolean;
  onMenuClick: () => void;
}

const Header = ({ isMobile, onMenuClick }: HeaderProps) => {
  const { theme, toggleTheme, logout, ...userDisplay } = useHeaderUser();

  return (
    <header className="sticky top-0 z-40 w-full bg-background/95 shadow-[0_1px_3px_0_rgb(0,0,0,0.04),0_1px_2px_-1px_rgb(0,0,0,0.04)] backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex h-14 items-center gap-4 border-b border-border/50 px-4 md:px-6">
        {isMobile && (
          <div className="flex items-center gap-2">
            <Button
              variant="ghost"
              size="icon"
              onClick={onMenuClick}
              className="text-muted-foreground hover:text-foreground"
            >
              <Menu className="h-5 w-5" />
              <span className="sr-only">Menu</span>
            </Button>

            <Link to="/" className="flex items-center transition-opacity hover:opacity-80">
              <img src={logo} alt="Hub Logo" className="h-7 w-auto dark:brightness-0 dark:invert" />
            </Link>
          </div>
        )}

        <div className="ml-auto flex items-center gap-1">
          <HeaderActions theme={theme} onToggleTheme={toggleTheme} />

          <div className="mx-2 hidden h-6 w-px bg-border/60 md:block" />

          <UserDropdown {...userDisplay} onLogout={logout} />
        </div>
      </div>

      <EnvironmentBar />

      <ComunicadosBoundary>
        <ComunicadoSistemaBar />
      </ComunicadosBoundary>
    </header>
  );
};

export default Header;
